import React, { memo, useMemo } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const MessageDateTimeMC = memo(({ message, dateFormat = 'DD-MM-YYYY HH:mm' }) => {
  const { i18n } = useTranslation('InboxMC');

  // Memoiza el cálculo de la fecha para evitar renders innecesarios
  const formattedDateTime = useMemo(() => {
    return moment(message.createdTime)
      .local()
      .locale(i18n.language)
      .format(dateFormat);
  }, [message.createdTime, i18n.language, dateFormat]);

  // Determina la clase según la dirección y el estado del mensaje
  const messageDateTimeClass = useMemo(() => {
    return 'tw-text-3xs tw-mt-3';
  }, [message.direction]);

  return (
    <div className="!tw-inline">
      <span className={messageDateTimeClass}>
        {formattedDateTime}
      </span>
    </div>
  );
});

MessageDateTimeMC.displayName = 'MessageDateTimeMC';

export default MessageDateTimeMC;
